import { useState } from "react";
import { ViewMoreIcon } from "../../../assets/icons";
import { GetAccess } from "../../../utils/RolesandAccess";
import CreateorUpdate from "./from";


function Viewmore({ fetcher, data }) {
  const [showMyModal, setShowMyModal] = useState(false);
  const handleOnClose = () => setShowMyModal(false);

  return (
    <>
      <div className="hover:drop-shadow-sm mr-2 py-2 px-[14px] rounded-3xl bg-white dropdown cursor-pointer relative">
        <ViewMoreIcon />
        <div className="hidden dropdown-menu">
          <div
            id="modal"
            className="bg-transparent fixed inset-0 flex justify-center items-center "
          ></div>
          <div className="bg-white rounded-xl w-20 text-left absolute -left-20 -top-1">
            <div className="grid p-1 rounded-t">
              {GetAccess("admin_edit") && (
                <span
                  className="p-1  hover:bg-navhover hover:rounded-lg cursor-pointer"
                  onClick={() => setShowMyModal(true)}
                >
                  Edit
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
      <CreateorUpdate
        onClose={handleOnClose}
        visible={showMyModal}
        data={data}
        refreshData={fetcher}
      />
    </>
  );
}

export default Viewmore;
